import { Button } from '@heroui/react';
import { SearchInput } from '@/components/common/SearchInput';
import { FilterSelect } from '@/components/common/FilterSelect';
import { DebouncedInput } from '@/components/common/DebouncedInput';

export type QueueFilters = Record<string, string>;

/** Delivery Center search + advanced filters. Reuses SearchInput / FilterSelect / DebouncedInput. */
export function QueueToolbar({ q, filters, onSearch, onFilter, onClear }: {
  q: string; filters: QueueFilters;
  onSearch: (v: string) => void; onFilter: (key: string, value: string) => void; onClear: () => void;
}) {
  const active = Object.values(filters).filter(Boolean).length + (q ? 1 : 0);
  return (
    <div className="flex flex-col gap-3 border-b border-border p-4">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
        <SearchInput value={q} onSearch={onSearch} placeholder="Search queue id, message id, sender, recipient…" className="lg:max-w-xs" ariaLabel="Search queued messages" />
        <div className="flex flex-wrap items-center gap-2">
          <FilterSelect ariaLabel="Tenant" placeholder="All tenants" value={filters['tenant'] ?? ''} onChange={(v) => onFilter('tenant', v)} options={[
            { key: 'Acme Corp', label: 'Acme Corp' }, { key: 'Acme.io', label: 'Acme.io' },
          ]} className="w-40" />
          <FilterSelect ariaLabel="Priority" placeholder="All priorities" value={filters['priority'] ?? ''} onChange={(v) => onFilter('priority', v)} options={[
            { key: 'high', label: 'High' }, { key: 'normal', label: 'Normal' }, { key: 'low', label: 'Low' },
          ]} className="w-40" />
          <FilterSelect ariaLabel="Status" placeholder="All statuses" value={filters['status'] ?? ''} onChange={(v) => onFilter('status', v)} options={[
            { key: 'delivering', label: 'Delivering' }, { key: 'deferred', label: 'Deferred' }, { key: 'retrying', label: 'Retrying' },
            { key: 'held', label: 'Held' }, { key: 'failed', label: 'Failed' }, { key: 'bounced', label: 'Bounced' },
          ]} className="w-40" />
          <FilterSelect ariaLabel="Threat" placeholder="Any threat" value={filters['threat'] ?? ''} onChange={(v) => onFilter('threat', v)} options={[
            { key: 'None', label: 'None' }, { key: 'Spam', label: 'Spam' }, { key: 'Phishing', label: 'Phishing' }, { key: 'Malware', label: 'Malware' },
          ]} className="w-36" />
          <FilterSelect ariaLabel="Age" placeholder="Any age" value={filters['age'] ?? ''} onChange={(v) => onFilter('age', v)} options={[
            { key: '1h', label: 'Older than 1h' }, { key: '6h', label: 'Older than 6h' }, { key: '1d', label: 'Older than 1 day' },
          ]} className="w-44" />
          <DebouncedInput label="Sender" placeholder="Sender…" value={filters.sender ?? ''} onCommit={(v) => onFilter('sender', v)} className="w-44" />
          <DebouncedInput label="Recipient" placeholder="Recipient…" value={filters.recipient ?? ''} onCommit={(v) => onFilter('recipient', v)} className="w-44" />
          <DebouncedInput label="Policy" placeholder="Policy…" value={filters.policy ?? ''} onCommit={(v) => onFilter('policy', v)} className="w-40" />
          {active > 0 && <Button size="sm" variant="light" onPress={onClear}>Clear ({active})</Button>}
        </div>
      </div>
    </div>
  );
}
